import { ThemeNames } from '@tenants/types';

export const DEFAULT_EXPIRE_DAYS = 7;
export const LOCATION_EXPIRE_DAYS = 28;
export const USER_EXPIRE_DAYS = 183;
export const ACCEPTED_TERMS_EXPIRE_DAYS = 365;
export const MLML_LEAD_EXPIRE_DAYS = 90;

// Controls how long smart chat cookies are valid for after user opts in/out
export const SMART_CHAT_OPT_IN_DAYS = 365;
export const SMART_CHAT_OPT_OUT_DAYS = 7;

export const ACCEPTED_TERMS_COOKIE_NAME = 'accepted-terms';

// eXp Realty US login role selection (Agent / Buyer or Seller / Other)
export const EXP_LOGIN_ROLE_COOKIE_NAME = 'exp_login_role';

export const ZOOCASA_TERMS_READ_COOKIE = 'zoocasa-terms-read';

export const POPULAR_CITIES_COOKIE = 'user-popular-cities';
export const DEVICE_ID_COOKIE = 'device-id';

const RECENT_SEARCHES = 'recent-searches';
const DETAILED_RECENT_SEARCHES = 'detailed-recent-searches';
const LAST_SEARCH_LOCATION = 'last-search-location';

export const NAV_BUTTON_COLLAPSED = 'nav-button-collapsed';
export const HIDE_SAVE_HOME_COOKIE = 'hide-save-home';

export const FIRST_VISIT_TIMESTAMP_KEY = 'first-visit-timestamp';
// sessionStorage-scoped: pins the first-visit-vs-recurring decision for the current
// browser tab session, so a refresh/reload doesn't re-derive it against a timestamp
// that an earlier mount in the same session already bumped.
export const FIRST_VISIT_SESSION_DECISION_KEY = 'first-visit-session-decision';
export const HIDE_APP_BANNER = 'hide-app-banner';

export const SEARCH_PAGE_MOBILE_SLIDE_UP_LISTING_DATA_COOKIE = 'search-page-mobile-slide-up-listing-data-cookie';
export const LIGHTBOX_ROTATE_DISCLAIMER = 'lightbox-rotate-disclaimer';

export const QUEBEC_POPUP = 'quebec-popup';
export const HOME_APPRAISAL_PROPERTY = 'home-appraisal-property';
export const HOME_APPRAISAL_DETAILS = 'home-appraisal-details';

export const getLastSearchLocationTag = (theme: ThemeNames): string=> {
  return LAST_SEARCH_LOCATION + '-' + theme;
};

export const getRecentSearchesTag = (theme: ThemeNames): string => {
  return RECENT_SEARCHES + '-' + theme;
};

// Separate storage key — deliberately not layered onto getRecentSearchesTag's
// list, so tenants without UseDetailedRecentSearches (and every existing
// consumer of the plain recent-searches list) are completely unaffected.
export const getDetailedRecentSearchesTag = (theme: ThemeNames): string => {
  return DETAILED_RECENT_SEARCHES + '-' + theme;
};

export const USER_LOCATION_COOKIE_NAME = 'user-location';
export const SITE_LOCATION_COOKIE_NAME = 'site-location';
export const SCREEN_COOKIE_NAME = 'screen';
export const USER_COOKIE_NAME = 'user';
export const JWT_COOKIE_NAME = 'jwt';
export const LOC_PICKER_COOKIE_NAME = 'loc-picker';
export const CONNECTION_REQUEST_DISCLAIMERS_COOKIE_NAME = 'connection-request-disclaimers';
export const NOTICE_GDPR_PREFS_COOKIE_NAME = 'notice_gdpr_prefs';
export const LISTING_PARAMS_COOKIE_NAME = 'listing-params';
export const SCHOOL_PARAMS_COOKIE_NAME = 'school-params';
export const MLML_LEAD_COOKIE_NAME = 'my-link-my-lead';
export const MLML_AGENT_COOKIE_NAME = 'agent-portal-token-cookie';
export const MLML_AGENT_TERMS_COOKIE_NAME = 'my-link-my-lead-create';
export const MLML_AGENT_TOOLTIP_COOKIE_NAME = 'my-link-my-lead-create-tooltip';

export const HIDE_NOTIFICATION_BANNER_COOKIE_NAME = 'hide-notification-banner';
export const HAS_SEEN_CHATBOT_WELCOME_COOKIE_NAME = 'has-seen-chatbot-welcome';
export const USE_AI_CHAT_COOKIE_NAME = 'use-ai-chat';
export const MAINTENANCE_BANNER_DISMISSED_COOKIE_NAME = 'maintenance-banner-dismissed';
export const FEEDBACK_BANNER_DISMISSED_COOKIE_NAME = 'feedback-banner-dismissed';
export const ENABLE_AI_ALPHA_CHAT_COOKIE_NAME = 'enable-ai-alpha-chat';
export const ENABLE_LOCAL_FOCUS_HOMEPAGE_COOKIE_NAME = 'enable-local-focus-homepage';
export const OVERRIDE_TENANT_COOKIE_NAME = 'override-tenant-id';
export const SMART_CHAT_BETA_COOKIE_NAME = 'smart_chat_beta';

export const AREA_PAGE_FOURTH_MAP_CARD_COOKIE_NAME = 'area-page-fourth-map-card';
export const AREA_PAGE_IGNORE_PROFILE_SETTINGS_IMAGELESS_COOKIE_NAME = 'area-page-temp-imageless';
export const MAP_SINGLE_LISTING_PREVIEW_COOKIE_NAME = 'map-single-cluster-experiment';
export const PROPERTY_DRAWER_AUTO_COLLAPSE_COOKIE_NAME = 'property-drawer-auto-collapse';
